import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { applyActionCode, getAuth } from 'firebase/auth';

export default function ConfirmNewEmail() {
  const [status, setStatus] = useState('Confirming your new email...');
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    let cancelled = false;

    const setSafeStatus = (next) => {
      if (!cancelled) {
        setStatus(next);
      }
    };

    const run = async () => {
      const oobCode = searchParams.get('oobCode');
      if (!oobCode) {
        setSafeStatus('Invalid or missing verification link.');
        return;
      }

      try {
        await applyActionCode(getAuth(), oobCode);
        setSafeStatus(
          'Your new email has been confirmed. Return to BlueWire and tap "I\'ve confirmed my new email" if prompted. Your profile email will sync automatically there.'
        );
      } catch (err) {
        console.error('Email confirmation error:', err);
        if (err?.code === 'auth/expired-action-code') {
          setSafeStatus('This email confirmation link has expired. Please request a new email change.');
          return;
        }
        if (err?.code === 'auth/invalid-action-code') {
          setSafeStatus('This email confirmation link is invalid or has already been used.');
          return;
        }
        setSafeStatus('Failed to confirm email. Please try again.');
      }
    };

    run();

    return () => {
      cancelled = true;
    };
  }, [searchParams]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="bg-white rounded-xl p-6 shadow w-full max-w-md text-center">
        <h2 className="text-xl font-semibold mb-4">Email Verification</h2>
        <p className="mb-4 text-gray-700">{status}</p>
        <button
          onClick={() => navigate('/login')}
          className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
        >
          Go to Login
        </button>
      </div>
    </div>
  );
}
